/** The printed answer cards' codebook (STORY-089 M2). Generated by
 * `scripts/gen_card_codebook.mjs` (seed 89; 8 to 17 ones; every rotation of every word
 * at Hamming distance 8 or more from every other, and every rotation of every word's mirror
 * image 6 or more from every rotated word), and frozen: a printed card must keep its
 * meaning, so a new encoding is a new set, never an edit.
 *
 * Card `n` (1 to 63) is `CODEBOOK[n - 1]`. Bit `r * 5 + c` is the data module in row `r` (0 at
 * the top) and column `c` (0 at the left) when the card is held with A at the top; 1 is black.
 * Numbers, not one string: the secrets scan flags long hex runs. */
export const CODEBOOK: readonly number[] = [
  31030183, 6242859, 29099343, 25202490, 6511269, 30528160, 26102475, 29854224,
  24939693, 15211466, 4557115, 33280332, 3250383, 32091322, 24283841, 11090604,
  7617492, 5554356, 7736622, 25061626, 18484360, 27522931, 9500470, 8606749,
  27646370, 15707215, 13156847, 2434352, 5380766, 4274770, 10226672, 23140505,
  30183238, 16218482, 17926181, 29332887, 24728809, 6168966, 21883040, 11868341,
  2852105, 19578906, 32363074, 19741962, 18808172, 13778893, 21782075, 18212368,
  23307094, 23729076, 17506983, 19413880, 32794417, 18231810, 4297854, 22490903,
  25376991, 15064532, 1262630, 637917, 32465173, 13117071, 31207094,
];
